import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TopBar from "../../topbar/TopBar";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/svg/nav-prev.svg";
import { ReactComponent as TickIcon } from "../../../assets/svg/tick.svg";
import { ReactComponent as CrossIcon } from "../../../assets/svg/close.svg";
import "./visitor-create.css";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import { createVisitorApi, gateInfoApi, getCheckList, getEnabledFieldApi, getGateListApi, getLocation, getMobileNumberBasedVisitor, getResponsiblePersonApi, sendOTPApi, updateVisitorApi, verifyOTPApi } from "../visitor-api.js";
import moment from "moment";
import { ReactComponent as CameraProofIcon } from "../../../assets/svg/camera1.svg";
import { ReactComponent as CameraIcon } from "../../../assets/svg/camera.svg";
import { ReactComponent as UploadIcon } from "../../../assets/svg/upload_btn.svg";
import { ReactComponent as UploadImg } from "../../../assets/svg/upload_img.svg";
import { ReactComponent as ItemImg } from "../../../assets/svg/item_img.svg";
import { ReactComponent as GuestImg } from "../../../assets/svg/guests.svg";
import { ReactComponent as AddItem } from "../../../assets/svg/add_item.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/svg/call.svg";
import { ReactComponent as ClockIcon } from "../../../assets/svg/clock 2.svg";
import SearchWithFreeTextAPI from "../../common/searchbox/searchbox-free-text.js";
import camera from "../../../assets/svg/camera.svg";
import { ReactComponent as SlotCloseIcon } from "../../../assets/svg/close-1.svg";
import { ReactComponent as ItemNameIcon } from "../../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import ProfileImage from "../../../assets/png/customer-icon.png";
import {
  Toast,
  ToastContainer,
} from "react-bootstrap";
import AddItemModal from "../../modal-dialog/add-item-modal.js";
import AddGuestModal from "./add-guest-modal.js";
import CheckListFailedModal from "../../modal-dialog/checklist-failed-modal.js";
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal.js";
import DOMPurify from 'dompurify';
import { FaCheck, FaTimes } from "react-icons/fa";
import PoweredBy from "../../common/poweredBy.jsx";

export const VisitorCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorId, } = location.state || {};

  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [gateOption, setGateOption] = useState(null);
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [loginPerson, setLoginPerson] = useState({});
  const [isProofMandatory, setIsProofMandatory] = useState(false);
  const [isChecklistMandatory, setIsChecklistMandatory] = useState(false);
  const [isOtpMandatory, setIsOtpMandatory] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOTP] = useState("");
  const [otpRef, setOTPRef] = useState("");
  const [isOTPSend, setIsOTPSend] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let interval = null;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [countdown]);
  const [visitorName, setVisitorName] = useState("");
  const [meetingType, setMeetingType] = useState("Direct");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [organization, setOrganization] = useState(null);
  const [purposeVisitOption, setPurposeVisitOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [email, setEmail] = useState("");
  const [checkList, setCheckList] = useState([]);
  const [errorCheckList, setErrorCheckList] = useState([]);
  const [isGuestEnable, setIsGuestEnable] = useState(false);
  const [isVisitorVehicleEnable, setVisitorVehicleEnable] = useState(false);
  const [departmentOption, setDepartmentOption] = useState(null);
  const [meetingPersonOption, setMeetingPersonOption] = useState(null);
  const [meetingPerson, setMeetingPerson] = useState("");
  const [proofType, setProofType] = useState("");
  const [proofNumber, setProofNumber] = useState("");
  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [selectedTab, setSelectedTab] = useState("Items");
  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [guestList, setGuestList] = useState([]);
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [isValidateCheckList, setValidateCheckList] = useState(true);

  const [checkListStatus, setCheckListStatus] = useState("pending");
  const [scheduleDateTime, setScheduleDateTime] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [showAddItemModal, setAddItemModal] = useState(false);
  const [showAddGuestModal, setAddGuestModal] = useState(false);
  const [showChecklistFailedModal, setChecklistFailedModal] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [validations, setValidations] = useState({
    "gate_id": "",
    "visitor_name": "",
    "meeting_type": "",
    "in_time": "",
    "organization": "",
    "mobile_number": "",
    "country_code": "",
    "otp_verification_status": "",
    "location_id": "",
    "department_id": "",
    "meeting_person": "",
    "purpose_of_visit": "",
    "proof_name": "",
    'email': "",
    "proof_value": "",
    "vehicletype_id": "",
    "vehicle_number": "",
    "items": "",
    "uploads": "",
    'profilephoto': "",
    'checklists': "",
    "validate_check_list": "",
    "check_list_status": "",
    "guests": "",
  });

  useEffect(() => {
    getGateList()
    getEnabledField()
  }, []);

  useEffect(() => {
    if (gateOption != null || departmentOption != null) {
      getEnabledField();
    }
  }, [gateOption, departmentOption]);

  const isFieldEnabled = (field) => {
    return enabledFields.some(item => item === field);
  }
  const isFieldMandatory = (field) => {
    return mandatoryFields.some(item => item === field);
  }

  const getGateList = async () => {
    try {
      const response = await getGateListApi();
      if (response.status === 200 && response.data.success === true) {
        if (response.data.suggestionlist.length > 0) {
          handleGateDropdownChange(response.data.suggestionlist[0]);
        }
      }

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleGateDropdownChange = (option) => {
    console.log(option)
    setGateOption(option);
    getLocationData(option.value)
    getGateInfo(option.value)
    getResponsiblePerson(option.value)
  };
  const handleMobileNumberDropdownChange = (option) => {
    setMobileNumber(option.value)
    getMobileNumberBasedVisitorData(option.value)
    setIsOTPSend(false)
  };
  const handleMobileNumberOnChange = (term) => {
    const cleaned = (term || "").replace(/\D/g, "").slice(0, 15);
    setMobileNumber(cleaned);
    setIsOTPSend(false);
    if (cleaned && cleaned.length > 0 && cleaned.length < 6) {
      setValidations((prev) => ({
        ...prev,
        mobile_number: "Mobile number must be between 6 and 15 digits",
      }));
    } else {
      setValidations((prev) => ({
        ...prev,
        mobile_number: "",
      }));
    }
  };
  const handleOrganizationDropdownChange = (option) => {
    console.log(option)
    setOrganization(option.value)
  };
  const handleOrganizationOnChange = (term) => {
    setOrganization(term)
  };


  const handlePurposeVisitDropdownChange = (option) => {
    console.log(option)
    setPurposeVisitOption(option)
  };
  const handleDepartmentDropdownChange = (option) => {
    console.log(option)
    setDepartmentOption(option)
  };
  const handleMeetingPersonDropdownChange = (option) => {
    console.log(option)
    setMeetingPersonOption(option)
  };

  const handleVehicleTypeDropdownChange = (option) => {
    console.log(option)
    setVehicleTypeOption(option)
  };

  const getMobileNumberBasedVisitorData = async (mobileNumber) => {

    try {
      const response = await getMobileNumberBasedVisitor(mobileNumber, 'Visitor');
      if (response.success === true && response.message !== "MobileNumber Not Available !!") {
        const visitorData = response.data;
        setGateOption({ 'value': visitorData.gate_id ?? '', 'label': visitorData.gate ?? 'Select' })
        setVisitorName(visitorData.visitor_name ?? '')
        setEmail(visitorData.email ?? '')
        setOrganization(visitorData.organization)
        setProofType(visitorData.proof_name ?? '')
        setProofNumber(visitorData.proof_value ?? '')
        setMeetingPersonOption({ 'value': visitorData.meeting_person ?? '', 'label': visitorData.meeting_person_name ?? 'Select' })
        setLocationOption({ 'value': visitorData.location_id ?? '', 'label': visitorData.location ?? 'Select' })
        setDepartmentOption({ 'value': visitorData.department_id ?? '', 'label': visitorData.department ?? 'Select' })
        setPurposeVisitOption({ 'value': visitorData.purpose_of_visit ?? '', 'label': visitorData.visit_purpose ?? 'Select' })
        getLocationData(visitorData.gate_id)

      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getLocationData = async (gateId) => {
    try {
      const response = await getLocation(gateId);
      if (response.status === true) {
        setLocationOption({ 'value': response.details.location_id, 'label': response.details.location });
        setIsGuestEnable(response.details.guest_enabled ?? false);
        setVisitorVehicleEnable(response.details.visitor_vehicle_info ?? false)
        getCheckListData(response.details.location_id)


      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEnabledField = async () => {
    const data = {
      "type": "Visitor",
      gate_id: gateOption != null ? gateOption.value : "",
      department_id: departmentOption != null ? departmentOption.value : "",
    }
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {})
        setMandatoryFields(response?.mandatory_fields ?? {})
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getGateInfo = async (gateId) => {
    const data = { "gate_id": gateId }
    try {
      const response = await gateInfoApi(data);
      if (response.success === true) {
        setIsProofMandatory(response?.gate_details?.proof_mandatory ?? false)
        setIsChecklistMandatory(response?.gate_details?.checklist_mandatory ?? false)
        setIsOtpMandatory(response?.gate_details?.otp_mandatory ?? false)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getResponsiblePerson = async (gateId) => {
    try {
      const response = await getResponsiblePersonApi(gateId);
      if (response.success === true) {
        setResponsiblePerson(response.responsible_person);
        setLoginPerson(response?.employee ?? '')
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCheckListData = async (locationId) => {

    try {
      const response = await getCheckList(locationId, 'Visitor');
      if (response.success === true) {
        setCheckList(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const sendOTPData = async (mobilenumber) => {
    setIsOTPSend(true);
    setLoadingOTP(true);
    setOTPRef("");
    setIsOTPVerified(false);
    setOTP("");
    setValidations(prev => ({
      ...prev,
      otp_verification_status: ""
    }));
    try {
      const response = await sendOTPApi({ 'template_name': 'Gate-Visitor-OTP', "mobilenumber": mobilenumber });
      if (response.success === true) {
        setOTPRef(response.otp_id);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
        setCountdown(30);
      } else {
        setValidations(prev => ({
          ...prev,
          otp_verification_status: response?.message || "Failed to send OTP"
        }));
      }
      return response.data;
    } catch (err) {
      console.error("Error sending OTP:", err);
    } finally {
      setLoadingOTP(false);
    }
  };

  const verifyOTP = async () => {
    setIsOTPVerified(false)
    const data = {
      "location_id": locationOption != null ? locationOption.value : '',
      "otp_id": otpRef,
      "received_otp": otp,
    }
    try {
      const response = await verifyOTPApi(data);
      if (response && (response.success === true || response.status === true)) {
        setIsOTPVerified(true)
        setSnackbarMessage(response.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        setValidations(prev => ({
          ...prev,
          otp_verification_status: ""
        }));
      } else {
        setIsOTPVerified(false);
        setValidations(prev => ({
          ...prev,
          otp_verification_status: response?.message || "Invalid OTP!"
        }));
      }
      return response?.data;
    } catch (err) {
      console.error("Error fetching category:", err);
      setIsOTPVerified(false);
      setValidations(prev => ({
        ...prev,
        otp_verification_status: "Invalid OTP!"
      }));
    } finally {
    }
  };


  // const submitVisitor = async (isCheckListValidate, checkListStatus) => {

  //   const dataBeforeSanitize = {
  //     "gate_id": gateOption != null ? gateOption.value : "",
  //     "visitor_name": visitorName,
  //     "meeting_type": meetingType,
  //     "in_time": meetingType === 'Direct' ? moment(new Date()).format("YYYY-MM-DD hh:mm") : scheduleDate + " " + scheduleTime,
  //     "organization": organization,
  //     "mobile_number": mobileNumber,
  //     "country_code": countryCode == "" ? "91" : countryCode,
  //     "otp_verification_status": isOTPVerified,
  //     "location_id": locationOption != null ? locationOption.value : "",
  //     "department_id": departmentOption != null ? departmentOption.value : "",
  //     "meeting_person": meetingPersonOption != null ? meetingPersonOption.value : "",
  //     "meeting_person_name": meetingPerson,
  //     "purpose_of_visit": purposeVisitOption != null ? purposeVisitOption.value : "",
  //     "proof_name": proofType,
  //     'email': email,
  //     "proof_value": proofNumber,
  //     "vehicletype_id": vehicleTypeOption != null ? vehicleTypeOption.value : "",
  //     "vehicle_number": vehicleNumber,
  //     "items": itemList.map((item) => ({
  //       "item_name": DOMPurify.sanitize(item.item_name),
  //       "quantity": DOMPurify.sanitize(item.quantity),
  //       "description": DOMPurify.sanitize(item.description)
  //     })),
  //     "uploads": base64FileList ?? [],
  //     'profilephoto': image ?? '',
  //     'checklists': meetingType === 'Schedule'
  //       ? null
  //       : checkList.map((check) => ({
  //         "id": DOMPurify.sanitize(check.id),
  //         "value": DOMPurify.sanitize(check.inputvalue?.toString())
  //       })),
  //     "validate_check_list": isCheckListValidate,
  //     "check_list_status": checkListStatus,
  //     "guests": guestList
  //   };
  //   const dataAfterSanitize = {};
  //   Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
  //     if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "items" || key === "checklists") {
  //       dataAfterSanitize[key] = value;
  //     } else {
  //       dataAfterSanitize[key] = DOMPurify.sanitize(value);
  //     }
  //   });
  //   const response = await createVisitorApi(dataAfterSanitize);
  //   if (response.status === 200) {
  //     if (response.data.status === true) {
  //       setSnackbarMessage(response.data.message);
  //       setSnackbarStatus(response.data.status);
  //       handleSnackbarShow();
  //       navigate(-1);
  //     }
  //   }
  //   if (response.status === 402) {
  //     setErrorCheckList(response.data.error)
  //   }
  //   if (response.status === 400) {
  //     new Promise((resolve, reject) => {

  //       const validationTemp = {
  //         "gate_id": "",
  //         "visitor_name": "",
  //         "meeting_type": "",
  //         "in_time": "",
  //         "organization": "",
  //         "mobile_number": "",
  //         "country_code": "",
  //         "otp_verification_status": "",
  //         "location_id": "",
  //         "department_id": "",
  //         "meeting_person": "",
  //         "purpose_of_visit": "",
  //         "proof_name": "",
  //         'email': "",
  //         "proof_value": "",
  //         "vehicletype_id": "",
  //         "vehicle_number": "",
  //         "items": "",
  //         "uploads": "",
  //         'profilephoto': "",
  //         'checklists': "",
  //         "validate_check_list": "",
  //         "check_list_status": "",
  //         "guests": "",
  //       };
  //       Object.entries(response.data.error).forEach(([key, value]) => {
  //         console.log(`${key}: ${value}`);
  //         validationTemp[key] = value.length === 0 ? '' : value[0];
  //       });
  //       console.log('validationTemp...', validationTemp);
  //       setValidations(validationTemp);
  //     });
  //   }
  // };
  const submitVisitor = async (isCheckListValidate, checkListStatus) => {
    try {

      const dataBeforeSanitize = {
        gate_id: gateOption != null ? gateOption.value : "",
        visitor_name: visitorName,
        meeting_type: meetingType,
        in_time:
          meetingType === "Direct"
            ? moment(new Date()).format("YYYY-MM-DD hh:mm")
            : scheduleDate + " " + scheduleTime,
        organization,
        mobile_number: mobileNumber,
        country_code: countryCode === "" ? "91" : countryCode,
        otp_verification_status: isOTPVerified,
        location_id: locationOption != null ? locationOption.value : "",
        department_id: departmentOption != null ? departmentOption.value : "",
        meeting_person:
          meetingPersonOption != null ? meetingPersonOption.value : "",
        meeting_person_name: meetingPerson,
        purpose_of_visit:
          purposeVisitOption != null ? purposeVisitOption.value : "",
        proof_name: proofType,
        email,
        proof_value: proofNumber,
        vehicletype_id:
          vehicleTypeOption != null ? vehicleTypeOption.value : "",
        vehicle_number: vehicleNumber,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: DOMPurify.sanitize(item.quantity),
          description: DOMPurify.sanitize(item.description),
        })),
        uploads: base64FileList ?? [],
        profilephoto: image ?? "",
        checklists:
          meetingType === "Schedule"
            ? null
            : checkList.map((check) => ({
              id: DOMPurify.sanitize(check.id),
              value: DOMPurify.sanitize(
                check.inputvalue?.toString()
              ),
            })),
        validate_check_list: isCheckListValidate,
        check_list_status: checkListStatus,
        guests: guestList,
      };

      const dataAfterSanitize = {};
      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "items" ||
          key === "checklists"
        ) {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });

      const response = await createVisitorApi(dataAfterSanitize);

      if (response.status === 200) {
        if (response.data.status === true || response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(true);
          handleSnackbarShow();
          navigate(-1);
        } else {
          if (response.data.error) {
            const validationTemp = {
              gate_id: "",
              visitor_name: "",
              meeting_type: "",
              in_time: "",
              organization: "",
              mobile_number: "",
              country_code: "",
              otp_verification_status: "",
              location_id: "",
              department_id: "",
              meeting_person: "",
              purpose_of_visit: "",
              proof_name: "",
              email: "",
              proof_value: "",
              vehicletype_id: "",
              vehicle_number: "",
              items: "",
              uploads: "",
              profilephoto: "",
              checklists: "",
              validate_check_list: "",
              check_list_status: "",
              guests: "",
            };
            Object.entries(response.data.error).forEach(([key, value]) => {
              validationTemp[key] = value?.[0] || "";
            });
            setValidations(validationTemp);
          } else {
            setSnackbarMessage(response.data.message || "Failed to create visitor");
            setSnackbarStatus(false);
            handleSnackbarShow();
          }
        }
      }

      if (response.status === 402) {
        setErrorCheckList(response.data.error);
      }

      if (response.status === 400) {
        const validationTemp = {
          gate_id: "",
          visitor_name: "",
          meeting_type: "",
          in_time: "",
          organization: "",
          mobile_number: "",
          country_code: "",
          otp_verification_status: "",
          location_id: "",
          department_id: "",
          meeting_person: "",
          purpose_of_visit: "",
          proof_name: "",
          email: "",
          proof_value: "",
          vehicletype_id: "",
          vehicle_number: "",
          items: "",
          uploads: "",
          profilephoto: "",
          checklists: "",
          validate_check_list: "",
          check_list_status: "",
          guests: "",
        };

        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = value?.[0] || "";
        });

        setValidations(validationTemp);
      }
    } catch (error) {
      console.error("Submit visitor failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  useEffect(() => {

    if (isCameraOpen === true) {
      setImage(null);
      getVideo();
    }

  }, [isCameraOpen])
  const getVideo = () => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      console.log("Devices start:", devices);
    });

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(stream => {
        streamRef.current = stream;
        console.log(videoRef.current)
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch(err => {
        console.error("Error accessing camera:", err);
      });
  };
  const stopVideo = () => {
    console.log(streamRef.current);

    if (streamRef.current) {
      console.log(streamRef.current.getTracks());
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;

    }
    console.log(videoRef.current);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setIsCameraOpen(false);
    forceStopCamera()
  };
  const forceStopCamera = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();

    if (devices.some((device) => device.kind === "videoinput")) {
      const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });

      tempStream.getTracks().forEach((track) => track.stop()); // Force stop

      console.log("Force-stopped extra video streams.");
    }
  };
  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Set canvas size to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame on the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to image URL
    const imageUrl = canvas.toDataURL("image/png");
    setImage(imageUrl);
  };

  const [isProofCameraOpen, setIsProofCameraOpen] = useState(false);
  const proofVideoRef = useRef(null);
  const proofStreamRef = useRef(null);
  const proofCanvasRef = useRef(null);

  useEffect(() => {
    if (isProofCameraOpen === true) {
      getProofVideo();
    }
  }, [isProofCameraOpen]);

  const getProofVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        proofStreamRef.current = stream;
        if (proofVideoRef.current) {
          proofVideoRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
      });
  };

  const stopProofVideo = () => {
    if (proofStreamRef.current) {
      proofStreamRef.current.getTracks().forEach((track) => track.stop());
      proofStreamRef.current = null;
    }
    if (proofVideoRef.current) {
      proofVideoRef.current.srcObject = null;
    }
    setIsProofCameraOpen(false);
  };

  const captureProofImage = () => {
    const video = proofVideoRef.current;
    const canvas = proofCanvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const imageUrl = canvas.toDataURL("image/png");

    const tempImages = [...selectedImageList];
    tempImages.push(imageUrl);
    setSelectedImageList(tempImages);

    const tempBase64 = [...base64FileList];
    tempBase64.push(imageUrl);
    setBase64FileList(tempBase64);

    stopProofVideo();
  };

  const [selectedImageList, setSelectedImageList] = useState([]);
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);
  const [removedImageList, setRemovedImageList] = useState([]);

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList)

      };
      reader.readAsDataURL(file);
      const tempImageList = [...selectedImageList];
      tempImageList.push(URL.createObjectURL(file));
      setSelectedImageList(tempImageList);
    } else {
      alert("Please select a valid image file.");
    }
    event.target.value = "";
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item)
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem)
  }

  const onSaveGuest = (itemData) => {
    setAddGuestModal(false);
    const tempGuest = [...guestList];
    if (itemData.index === null) {
      tempGuest.push(itemData.guest)
    } else {
      tempGuest[itemData.index] = itemData.guest;
    }
    setGuestList(tempGuest)
  }

  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null); // Close the alert
    }
  };
  const onProceedCheckList = () => {
    setChecklistFailedModal(false);
    setChecklistFailedAdminModal(false);
    setValidateCheckList(false)
    submitVisitor(false, 'pending')

  }
  const onApprovedCheckList = () => {

    setValidateCheckList(false)
    setChecklistFailedAdminModal(false);
    setCheckListStatus('approve')
    submitVisitor(false, 'approve')
  }
  useEffect(() => {
    if (errorCheckList.length > 0) {
      console.log(loginPerson)
      console.log(responsiblePerson)
      if (responsiblePerson === loginPerson.id) {
        setChecklistFailedAdminModal(true)
      } else {
        setChecklistFailedModal(true)
      }

    }
  }, [errorCheckList])
  return (
    <Container fluid className="main-container">
      {showAddItemModal && <AddItemModal moduleName={"Visitor"} itemData={itemData} onSave={onSaveItem} onCancel={() => { setAddItemModal(false); setItemData(null) }} />}
      {showAddGuestModal && <AddGuestModal enabledFields={enabledFields} mandatoryFields={mandatoryFields} itemData={itemData} onSave={onSaveGuest} onCancel={() => { setAddGuestModal(false); setItemData(null) }} />}
      {showChecklistFailedModal && <CheckListFailedModal checkList={errorCheckList} loginPerson={loginPerson} onSave={onProceedCheckList} onCancel={() => { setChecklistFailedModal(false); }} />}
      {showChecklistFailedAdminModal && <CheckListFailedAdminModal checkList={errorCheckList} visitorName={visitorName} organization={organization ?? ''} visitorPicture={image ?? ''} isSaveEnable={true} onSave={onProceedCheckList} isApprovedEnable={true} onApproved={onApprovedCheckList} onCancel={() => { setChecklistFailedAdminModal(false); }} />}
      <div style={{ width: "100vw" }}>
        <TopBar currentName="visitor" />
        <Row sm={12} className="main-row">
          <Col className="mx-2 " sm={12} style={{ padding: "16px" }}>
            <Row sm={12}>
              <Col sm={6} md={9}>
                <div className="style-justify-start">
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BackIcon />
                  </div>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#21272C",
                    }}
                  >
                    Add visitor
                  </span>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="style-justify-end" style={{ gap: "8px" }}>
                  <div
                    className="cancel_btn"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#21272C",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    className="success_btn"
                    style={{
                      width: "100px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: isSubmitting ? "not-allowed" : "pointer",
                    }}

                    onClick={() => {
                      if (isSubmitting) return;
                      setIsSubmitting(true);
                      submitVisitor(true, "pending");
                    }}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm text-light"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#FFFFFF",
                        }}
                      >
                        Submit
                      </span>
                    )}
                  </div>

                </div>
              </Col>
            </Row>
            <Row className="mt-3 ">
              <Col xs={12} sm={12} lg={6}>
                <div className="card-view">
                  <div className="style-justify-start">
                    <div className="gate-title" style={{ width: '120px' }}>Entry gate<span style={{ color: '#FF4444' }}>*</span> : </div>
                    <div className="w-100">
                      <SearchWithAPI onDropdownChange={handleGateDropdownChange} apiUrl={apiUrl + "gate/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={gateOption} />
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.gate_id}</span>
                    </div>
                  </div>
                </div>
                <div className="card-view mt-3">
                  <div className="card-title">Verify visitor mobile number</div>
                  <Row style={{ display: "flex" }}>
                    {/* {isFieldEnabled("Mobile number") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Mobile number{isFieldMandatory("Mobile number") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div
                        className="style-justify-start-start mt-1"
                        style={{ gap: "8px" }}
                      >
                        <div style={{ width: "68%" }}>
                          {/* <input
                            style={{ width: "100%" }}
                            type="text"
                            placeholder="Mobile number "
                            className="input-field"
                            value={mobileNumber}
                            onChange={(event) => {
                              const value = event.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove non-numeric characters
                              setMobileNumber(value);
                            }}
                          /> */}
                          <SearchWithFreeTextAPI numberOnly={true} readOnly={isOTPVerified === true ? true : false} onDropdownChange={handleMobileNumberDropdownChange} onChangeSearch={handleMobileNumberOnChange} apiUrl={apiUrl + `mobile_autocomplete`} params={{ type: "Visitor" }} searchLimit={6} placeholder={"Select"} selectedValue={mobileNumber} />

                        </div>
                        {meetingType === 'Direct' && (<div
                          className="success_btn "
                          style={{
                            width: "30%",
                            cursor: (!loadingOTP && countdown === 0 && mobileNumber && mobileNumber.trim().length >= 6 && mobileNumber.trim().length <= 15) ? "pointer" : "not-allowed",
                            opacity: (!loadingOTP && countdown === 0 && mobileNumber && mobileNumber.trim().length >= 6 && mobileNumber.trim().length <= 15) ? 1 : 0.6
                          }}
                          onClick={() => {
                            if (!loadingOTP && countdown === 0 && mobileNumber && mobileNumber.trim().length >= 6 && mobileNumber.trim().length <= 15) {
                              sendOTPData(mobileNumber);
                            }
                          }}
                        >
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#FFFFFF",
                            }}
                          >
                            {!isOTPSend ? 'Get Code' : countdown > 0 ? `Resend ${countdown}s` : 'Get Code'}
                          </div>
                        </div>)}
                      </div>
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.mobile_number}</span>
                    </Col>
                    {isFieldEnabled("Mobile number") && meetingType === 'Direct' && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">OTP verification {isOtpMandatory && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1" style={{ position: "relative" }}>
                        <div>
                          <input
                            type="text"
                            readOnly={isOTPVerified === true ? true : false}
                            placeholder="Enter here "
                            className="input-field w-100"
                            value={otp}
                            onChange={(event) => {
                              const value = event.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove non-numeric characters
                              setOTP(value);
                              setValidations(prev => ({
                                ...prev,
                                otp_verification_status: ""
                              }));
                            }}
                          />
                        </div>
                        {isOTPVerified === false && (<button
                          className="btn btn-primary verify-btn"
                          type="button"
                          style={{ opacity: otpRef !== "" ? 1 : 0.6 }}
                          onClick={() => { otpRef !== "" && verifyOTP() }}
                        >
                          Verify
                        </button>)}
                      </div>
                      {isOTPVerified === true && (<span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#2C8C53", }}>Verified</span>)}
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.otp_verification_status}</span>
                    </Col>)}

                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Visitor Name<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={visitorName}
                            onChange={(event) => {
                              setVisitorName(event.target.value);
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.visitor_name}</span>
                      </div>
                    </Col>
                    {/* {isFieldEnabled("Department") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Department{isFieldMandatory("Department") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.department_id}</span>
                        </div>
                      </div>
                    </Col>{/* )} */}
                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Meeting Type</div>
                      <div className="mt-1">
                        <div>
                          <select className="select3 w-100 input-field" id="perpage" value={meetingType} onChange={(event) => { setMeetingType(event.target.value); }} style={{ cursor: 'pointer', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#8790A1', height: '40px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 8px', gap: '77px', backgroundColor: '#FFFFFF' }}>
                            <option value="">Select</option>
                            <option value="Direct">Direct</option>
                            <option value="Schedule">Schedule</option>
                          </select>
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.meeting_type}</span>
                        </div>
                      </div>
                    </Col>
                    {meetingType === 'Schedule' && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Date & Time</div>
                      <Row className="mt-1">
                        <Col sm={7} >
                          <div>
                            <input
                              type="date"
                              placeholder="Enter here"
                              className="input-field w-100"
                              value={scheduleDate}
                              onChange={(event) => {
                                setScheduleDate(event.target.value);
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={5} className="px-0" >
                          <div>
                            <input
                              type="time"
                              placeholder="Enter here"
                              className="input-field w-100"
                              value={scheduleTime}
                              onChange={(event) => {
                                setScheduleTime(event.target.value);
                              }}
                            />
                          </div>
                        </Col>

                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.in_time}</span>
                      </Row>
                    </Col>)}

                    {isFieldEnabled("Organization") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">From Organization{isFieldMandatory("Organization") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          {/* <SearchWithAPI onDropdownChange={handleOrganizationDropdownChange} apiUrl={apiUrl+"visitors/organization"} params={{}} placeholder={"Organization"} selectedOption={organization}/> */}
                          <SearchWithFreeTextAPI onDropdownChange={handleOrganizationDropdownChange} onChangeSearch={handleOrganizationOnChange} apiUrl={apiUrl + `visitors/organization`} params={{ type: "Visitor" }} searchLimit={0} placeholder={"Organization"} selectedValue={organization} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.organization}</span>
                        </div>
                      </div>
                    </Col>)}

                    {isFieldEnabled("Location") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Location{isFieldMandatory("Location") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder=""
                            className="input-field w-100"
                            value={locationOption?.label ?? ''} readOnly="true"
                          />
                        </div>
                      </div>
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.location_id}</span>
                    </Col>)}

                    {isFieldEnabled("Email") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Email{isFieldMandatory("Email") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="email"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={email}
                            onChange={(event) => {
                              setEmail(event.target.value);
                            }}
                          />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.email}</span>
                        </div>
                      </div>
                    </Col>)}
                  </Row>
                </div>


                {meetingType === 'Direct' && checkList.length > 0 && (<div className="card-view mt-2">
                  <div className="card-title">Check list {isChecklistMandatory && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.check_list_status}</span>
                  <div className="mt-3" style={{ gap: '8px' }}>
                    {checkList.map((check, index) => {
                      if (check.inputvalue == null) {
                        check["inputvalue"] = "";
                      }
                      const checklistError = validations[`checklists.${index}.value`];
                      const cleanError = checklistError
                        ? checklistError.replace(/the checklists\.\d+\.value field/i, `"${check.checkname}"`).replace(/the checklists\.\d+\.value/i, `"${check.checkname}"`)
                        : "";
                      return (
                        <div key={"checklist" + index} className="mb-2">
                          <div className="check-list style-justify-between">
                            <div>{check.checkname}</div>
                            {check.creteria !== "Boolean" && (<div >
                              <input
                                style={{ width: "100px" }}
                                type="text"
                                placeholder={check.checkname}
                                className="input-field"
                                value={check.inputvalue}
                                onChange={(event) => {
                                  const value = event.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                  const tempChecklist = [...checkList];
                                  tempChecklist[index]["inputvalue"] = value
                                  setCheckList(tempChecklist)
                                  setValidations(prev => ({
                                    ...prev,
                                    [`checklists.${index}.value`]: ""
                                  }));
                                }}
                              />
                            </div>)}

                            {check.creteria === "Boolean" && (<div className="style-justify-start" style={{ gap: '8px' }}>
                              <div className={`checklist-bool style-justify-start ${check.inputvalue ? "active-bool-btn" : ""}`} onClick={() => {
                                const tempChecklist = [...checkList];
                                tempChecklist[index]["inputvalue"] = true
                                setCheckList(tempChecklist)
                                setValidations(prev => ({
                                  ...prev,
                                  [`checklists.${index}.value`]: ""
                                }));
                              }}>
                                <FaCheck style={{ color: check.inputvalue ? 'white' : '#172B4D' }} />  <div style={{ paddingLeft: '8px' }}> Yes</div>
                              </div>
                              <div className={`checklist-bool style-justify-start ${check.inputvalue === false ? "in-active-bool-btn" : ""}`} onClick={() => {
                                const tempChecklist = [...checkList];
                                tempChecklist[index]["inputvalue"] = false
                                setCheckList(tempChecklist)
                                setValidations(prev => ({
                                  ...prev,
                                  [`checklists.${index}.value`]: ""
                                }));
                              }}>
                                <FaTimes style={{ color: check.inputvalue === false ? 'white' : '#172B4D' }} />
                                <div style={{ paddingLeft: '8px' }}> No</div>
                              </div>
                            </div>)}
                          </div>
                          {cleanError && (
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "end", fontSize: "11px", fontWeight: 400, color: "#FF4444", marginTop: "2px" }}>
                              {cleanError}
                            </span>
                          )}
                        </div>
                      );
                    }
                    )}
                  </div>
                </div>)}
              </Col>
              <Col xs={12} sm={12} lg={6}>

                <div className="card-view">
                  <div className="style-justify-between">
                    <div className="card-title">Visit details</div>
                    {meetingType === 'Direct' && (<div className="today-date-time style-justify-center">
                      <ClockIcon />
                      <div className="px-2">{moment(new Date()).format("DD MMM YYYY [at] hh:mm A")}</div>
                    </div>)}
                  </div>

                  <Row style={{ display: "flex" }}>
                    {isFieldEnabled("Purpose of visit") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Purpose of visit{isFieldMandatory("Purpose of visit") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handlePurposeVisitDropdownChange} apiUrl={apiUrl + "visit/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={purposeVisitOption} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.purpose_of_visit}</span>
                        </div>
                      </div>
                    </Col>)}

                    {isFieldEnabled("Meeting person") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Meeting person{isFieldMandatory("Meeting person") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={meetingPerson}
                            onChange={(event) => {
                              setMeetingPerson(event.target.value);
                            }}
                          />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.meeting_person_name}</span>
                        </div>
                      </div>
                    </Col>)}

                    {isFieldEnabled("Meeting person") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Meeting person{isFieldMandatory("Meeting person") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleMeetingPersonDropdownChange} apiUrl={apiUrl + "get_meeting_person"} params={{}} placeholder={"Select"} selectedOption={meetingPersonOption} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.meeting_person}</span>
                        </div>
                      </div>
                    </Col>)}
                  </Row>
                </div>

                {(isFieldEnabled("Proof") || isFieldEnabled("Profile Photo")) && (<div className="card-view mt-3">
                  {isFieldEnabled("Proof") && (<div className="card-title">Proof details</div>)}

                  <Row style={{ display: "flex" }}>
                    {isFieldEnabled("Proof") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">Proof{isFieldMandatory("Proof") && <span style={{ color: "#FF4444" }}>*</span>}</div>
                        <div className="mt-1">
                          <div>
                            <select
                              className="select3 w-100 input-field"
                              id="perpage"
                              value={proofType}
                              onChange={(event) => {
                                setProofType(event.target.value);
                              }}
                              style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500", lineHeight: "18.9px", color: "#8790A1", height: "40px", borderRadius: "10px", border: "0.7px solid #E5E5E5", padding: "0 8px", gap: "77px", backgroundColor: "#FFFFFF" }}
                            >
                              <option value="">Select</option>
                              <option value="adahar">Aadhaar</option>
                              <option value="pan">Pan</option>
                              <option value="driving">Driving License</option>
                            </select>
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.proof_name}</span>
                          </div>
                        </div>
                      </Col>
                    )}

                    {proofType !== "" && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">Proof Number{isFieldMandatory("Proof") && <span style={{ color: "#FF4444" }}>*</span>}</div>
                        <div className="mt-1">
                          <div>
                            <input
                              style={{ width: "100%" }}
                              type="text"
                              placeholder="Enter here "
                              className="input-field"
                              value={proofNumber}
                              onChange={(event) => {
                                if (proofType === "adahar") {
                                  const value = event.target.value.replace(/\D/g, "");
                                  setProofNumber(value);
                                } else {
                                  setProofNumber(event.target.value);
                                }
                              }}
                            />
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.proof_value}</span>
                          </div>
                        </div>
                      </Col>
                    )}
                    {isFieldEnabled("Proof") && (
                      <Col sm={12} lg={12}>
                        <div className="dotted-line "></div>
                      </Col>
                    )}
                    {isFieldEnabled("Profile Photo") && <div className="card-title">Upload proof image{isFieldMandatory("Profile Photo") && <span style={{ color: "#FF4444" }}>*</span>}</div>}
                    <Row>
                      {isFieldEnabled("Profile Photo") && (
                        <Col sm={12} lg={6} className="mt-3">
                          {isCameraOpen === false && (
                            <div className="proof-card-view ">
                              <div>
                                <CameraProofIcon />
                              </div>
                              <div className="proof-photo-title mt-2">Take a photo of person</div>
                              <div>
                                <div
                                  className="proof-btn mt-2 style-justify-center"
                                  onClick={() => {
                                    setIsCameraOpen(true);
                                  }}
                                >
                                  <CameraIcon />
                                  <div className="proof-btn-txt ">Open Camera</div>
                                </div>
                              </div>
                            </div>
                          )}
                          {isCameraOpen === true && (
                            <div>
                              {image == null && (
                                <div style={{ position: "relative" }}>
                                  <video
                                    ref={videoRef}
                                    autoPlay
                                    playsInline
                                    style={{
                                      width: "100%",
                                      height: "80%",
                                      borderRadius: "7px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div
                                    onClick={() => {
                                      stopVideo();
                                    }}
                                    style={{ position: "absolute", top: "10px", right: "10px" }}
                                  >
                                    <CrossIcon />
                                  </div>
                                  <div
                                    onClick={() => {
                                      captureImage();
                                    }}
                                    style={{ position: "absolute", bottom: "10px", left: "45%" }}
                                  >
                                    <img src={camera} style={{ width: "30px", height: "30px", margin: "0" }} />
                                  </div>
                                </div>
                              )}
                              <canvas ref={canvasRef} style={{ display: "none" }} />
                            </div>
                          )}
                          {image != null && (
                            <div style={{ position: "relative" }}>
                              <img src={image} alt="Captured" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                              <div
                                onClick={() => {
                                  setIsCameraOpen(false);
                                  setImage(null);
                                }}
                                style={{ position: "absolute", top: "10px", right: "10px" }}
                              >
                                <CrossIcon />
                              </div>
                            </div>
                          )}
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.profilephoto}</span>
                        </Col>
                      )}
                      {isFieldEnabled("Proof attachment") && (
                        <Col sm={12} lg={6} className="mt-3">
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            onChange={handleFileChange}
                            style={{ display: "none" }} // Hide the actual file input
                          />
                          <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                            {urlImageList.map((urlImage, index) => (
                              <div key={"url-image-" + index} className="mt-3" style={{ position: "relative" }}>
                                <img src={urlImage != null && urlImage !== "" ? urlImage.image : ""} alt="complaint" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "1px",
                                    right: "1px",
                                  }}
                                >
                                  <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <SlotCloseIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        const tempRemoved = [...removedImageList];
                                        tempRemoved.push(urlImage.id);
                                        removedImageList(tempRemoved);
                                        const tempURLImageList = [...urlImageList];
                                        tempURLImageList.splice(index, 1);

                                        setUrlImageList(tempURLImageList);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                            {selectedImageList.map((baseImage, index) => (
                              <div key={"base-image-" + index} className="mt-3" style={{ position: "relative" }}>
                                <img src={baseImage != null && baseImage !== "" ? baseImage : ""} alt="complaint" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "1px",
                                    right: "1px",
                                  }}
                                >
                                  <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <SlotCloseIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        const tempImageList = [...selectedImageList];
                                        tempImageList.splice(index, 1);
                                        setSelectedImageList(tempImageList);
                                        const tempBase64FileList = [...base64FileList];
                                        tempBase64FileList.splice(index, 1);
                                        setBase64FileList(tempBase64FileList);
                                        /* setSelectedFile(null);setSelectedImage(null); */
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="proof-card-view">
                            {isProofCameraOpen === true && (
                              <div style={{ position: "relative", marginBottom: "8px" }}>
                                <video ref={proofVideoRef} autoPlay playsInline style={{ width: "100%", borderRadius: "7px", objectFit: "cover" }} />
                                <div
                                  onClick={() => {
                                    stopProofVideo();
                                  }}
                                  style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer" }}
                                >
                                  <CrossIcon />
                                </div>
                                <div
                                  onClick={() => {
                                    captureProofImage();
                                  }}
                                  style={{ position: "absolute", bottom: "10px", left: "45%", cursor: "pointer" }}
                                >
                                  <img src={camera} style={{ width: "30px", height: "30px", margin: "0" }} alt="capture" />
                                </div>
                                <canvas ref={proofCanvasRef} style={{ display: "none" }} />
                              </div>
                            )}
                            {isProofCameraOpen === false && (
                              <>
                                <div>
                                  <UploadImg />
                                </div>
                                <div className="proof-photo-title mt-2">Upload proof image{isFieldMandatory("Proof attachment") && <span style={{ color: "#FF4444" }}>*</span>}</div>
                                <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                                  <div
                                    className="proof-btn style-justify-center"
                                    onClick={() => {
                                      setIsProofCameraOpen(true);
                                    }}
                                  >
                                    <CameraIcon />
                                    <div className="proof-btn-txt">Camera</div>
                                  </div>
                                  <div className="proof-btn style-justify-center" onClick={handleFileClick}>
                                    <UploadIcon />
                                    <div className="proof-btn-txt">Upload</div>
                                  </div>
                                </div></>
                            )}

                          </div>
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.uploads}</span>
                        </Col>
                      )}
                    </Row>
                  </Row>
                </div>
                )}

                {isVisitorVehicleEnable === true && ((isFieldEnabled("Vehicle type") || isFieldEnabled("Vehicle number"))) && <div className="card-view mt-3">
                  <div className="card-title">Vehicle details</div>

                  <Row style={{ display: "flex" }}>

                    {isFieldEnabled("Vehicle type") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Vehicle type{isFieldMandatory("Vehicle type") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleVehicleTypeDropdownChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={vehicleTypeOption} />
                          {/*  <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.profilephoto}</span> */}
                        </div>
                      </div>
                    </Col>)}

                    {isFieldEnabled("Vehicle number") && (<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Vehicle Number{isFieldMandatory("Vehicle number") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            placeholder="Enter here "
                            className="input-field"
                            value={vehicleNumber}
                            onChange={(event) => {
                              setVehicleNumber(event.target.value);
                            }}
                          />
                          {/*  <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.profilephoto}</span> */}
                        </div>
                      </div>
                    </Col>)}


                  </Row>
                </div>}

                <div className="card-view mt-3">
                  <div className="style-justify-start" style={{ gap: '8px' }}>
                    <div onClick={() => { setSelectedTab("Items") }} className={`tab-view style-justify-center ${selectedTab === 'Items' ? "selected-tab" : ""}`}>
                      Items
                    </div>
                    {isGuestEnable && (<div onClick={() => { setSelectedTab("Guests") }} className={`tab-view style-justify-center ${selectedTab === 'Guests' ? "selected-tab" : ""}`}>
                      Guests
                    </div>)}
                  </div>
                  {selectedTab === "Items" && itemList.length > 0 && (<Col sm={12} lg={12} className="mt-3">

                    <div className="item-list-header" style={{ flex: '12', }}>

                      <span className="item-list-header-txt style-justify-start" style={{ flex: '4' }}><ItemNameIcon style={{ marginRight: '8px' }} />Item Name</span>
                      <span className="item-list-header-txt style-justify-start" style={{ flex: '3' }}><QuantityIcon style={{ marginRight: '8px' }} />Quantity</span>
                      <span className="item-list-header-txt style-justify-start" style={{ flex: '5' }}><DescriptionIcon style={{ marginRight: '8px' }} />Description</span>

                    </div>
                    <div>
                      {itemList.map((item, index) => (
                        <div key={'item-list' + index}>

                          <               div className="item-list-row" style={{ flex: '12', }}>

                            <span className="item-list-row-txt" style={{ flex: '4' }}>{item.item_name}</span>
                            <span className="item-list-row-txt" style={{ flex: '3' }}>{item.quantity}</span>
                            <div className="item-list-row-txt" style={{ flex: '5', position: "relative" }} >
                              <span >{item.description}</span>
                              <div style={{ position: "absolute", position: 'absolute', top: "5px", right: "5px", }}>
                                <div style={{ position: "relative" }}>
                                  <MoreIcon style={{ cursor: 'pointer' }} onClick={() => { setAlertItemIndex(index === alertItemIndex ? null : index); }} />
                                  {alertItemIndex === index && (
                                    <div ref={alertRef} style={{
                                      position: "absolute",
                                      top: "40px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      backgroundColor: "#ffffff",
                                      color: "#1E1E1E",
                                      padding: "16px",
                                      borderRadius: "16px",
                                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                      zIndex: 1, alignItems: 'end',
                                    }}>
                                      <div onClick={() => { setItemData({ "item": item, "index": index }); setAddItemModal(true); setAlertItemIndex(null) }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                        Edit
                                      </div>
                                      <div onClick={() => {
                                        const tempItems = [...itemList];
                                        tempItems.splice(index, 1);
                                        setItemList(tempItems)
                                        setAlertItemIndex(null)
                                      }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>))}
                    </div>
                    <div className="mt-2 style-justify-start">
                      <div
                        className="add-item-btn style-justify-center"
                        onClick={() => {
                          setAlertItemIndex(null)
                          setAddItemModal(true);
                        }}
                      >
                        <AddItem />
                        <div >
                          Add item
                        </div>
                      </div>
                    </div>
                  </Col>)}
                  {selectedTab === "Items" && itemList.length === 0 && (<Col sm={12} lg={12} className="mt-3">
                    <div className="grid-view">
                      <div><ItemImg /></div>
                      <div className="item-add-title mt-2">
                        Visitor has items? Add them here
                      </div>
                      <div>
                        <div
                          className="proof-btn mt-2 style-justify-center"
                          onClick={() => {
                            setAddItemModal(true);
                          }}
                        >
                          <AddItem />
                          <div className="proof-btn-txt add-item">
                            Add item
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>)}

                  {selectedTab === "Guests" && guestList.length === 0 && (<Col sm={12} lg={12} className="mt-3">
                    <div className="grid-view">
                      <div><GuestImg /></div>
                      <div className="item-add-title mt-2">
                        Visitor has guests? Add them here
                      </div>
                      <div>
                        <div
                          className="proof-btn mt-2 style-justify-center"
                          onClick={() => {
                            setAddGuestModal(true);
                          }}
                        >
                          <AddItem />
                          <div className="proof-btn-txt add-item">
                            Add guest
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>)}
                  {selectedTab === "Guests" && guestList.length > 0 && (<Col>
                    <div>
                      {guestList.map((item, index) => (
                        <div className="mt-2" style={{ position: "relative" }}>
                          <div className="guest-item style-justify-start" style={{ flex: 15 }}>
                            <div style={{ flex: '2' }}>
                              <img className="guest-image-list" src={item['image'] != null && item['image'] !== '' ? item['image'] : ProfileImage} alt="guest" />
                            </div>
                            <div style={{ flex: '4', paddingLeft: '4px' }}>
                              <div className="guest-name">{item.name ?? ''}</div>
                              <div className="style-justify-start guest-phone"><PhoneIcon /><span style={{ paddingLeft: '8px' }}>{item.mobile_no ?? ''}</span></div>
                              <div className="guest-name"><span className="guest-age-title">Age :</span><span className="guest-age-value">{item.age ?? ''}</span></div>
                            </div>
                            <div style={{ height: '37px', borderRight: '1.5px solid #E5E5E5' }}></div>
                            <div style={{ flex: '3', paddingLeft: '8px' }}>
                              <div className="relation-type">Relation Type</div>
                              <div className="relation-type-value mt-1">{item.type ?? ''}</div>
                            </div>
                            <div style={{ flex: '5' }}>
                              <div className="relation-type">Proof</div>
                              <div className="style-justify-between guest-phone mt-1">
                                <div className="relation-type-value">{item.proof_name ?? ''}</div>
                                <div className="dot"></div>
                                <div className="style-justify-center proof-type">
                                  <div className="px-2">{item.proof_value ?? ''}</div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div style={{ position: "absolute", top: "5px", right: "5px", }}>
                            <div style={{ position: "relative" }}>
                              <MoreIcon style={{ cursor: 'pointer' }} onClick={() => { setAlertItemIndex(index === alertItemIndex ? null : index); }} />
                              {alertItemIndex === index && (
                                <div ref={alertRef} style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "#ffffff",
                                  color: "#1E1E1E",
                                  padding: "16px",
                                  borderRadius: "16px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                  zIndex: 1, alignItems: 'end',
                                }}>
                                  <div onClick={() => { setItemData({ "guest": item, "index": index }); setAddGuestModal(true); setAlertItemIndex(null) }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                    Edit
                                  </div>
                                  <div onClick={() => {
                                    const tempGuest = [...guestList];
                                    tempGuest.splice(index, 1);
                                    setGuestList(tempGuest)
                                    setAlertItemIndex(null)
                                  }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                    Delete
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>))}
                    </div>
                    <div className="mt-2 style-justify-start">
                      <div
                        className="proof-btn mt-2 style-justify-center"
                        onClick={() => {
                          setAlertItemIndex(null)
                          setAddGuestModal(true);
                        }}
                      >
                        <AddItem />
                        <div className="proof-btn-txt add-item">
                          Add guest
                        </div>
                      </div>
                    </div>
                  </Col>)}

                </div>
              </Col>
            </Row>
          </Col>
        </Row>

      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};
